import React, { useMemo } from "react";
import katex from "katex";
import "katex/dist/katex.min.css";
import { formulaToLatex } from "./formulaToLatex";

const FormulaKatex = ({ formula }) => {
  const html = useMemo(() => {
    const latex = formulaToLatex(formula);
    if (!latex) return null;
    try {
      return katex.renderToString(latex, {
        throwOnError: false,
        displayMode: true,
        output: "html",
      });
    } catch (e) {
      return null;
    }
  }, [formula]);

  if (!formula) return null;

  if (!html) {
    return (
      <pre className="regles-calcul__formula-fallback">
        <code>{formula}</code>
      </pre>
    );
  }

  return (
    <div
      className="regles-calcul__formula"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default FormulaKatex;
